import React from 'react';
import FontAwesome from 'react-fontawesome';


class FontSelectItem extends React.Component {

    constructor(props) {
        super(props);

        this.handleSelect = this.handleSelect.bind(this);
    }

    handleSelect(e) {
        e.preventDefault();
        this.props.onFontSelect(this.props.font);
    }

    render() {

        // hide if font not active
        if (!this.props.font.active)
            return null;

        const fontStyle = {
            fontFamily: this.props.font.id
        }
        return (
            <div className="col-xs-6 col-md-4 col-lg-3">
                <a className="font_select_item" href="#" onClick={this.handleSelect} style={fontStyle}>
                    {this.props.active ? <FontAwesome name='check-circle-o' /> : <FontAwesome name='circle-o' />}
                    <span>&nbsp;</span>
                    {this.props.font.title}: {this.props.font.text}
                </a>
            </div>
        );
    }
  }
export default FontSelectItem;



// WEBPACK FOOTER //
// ./src/FontSelectItem.js